import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './OneBlog.css';

function OneBlog() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        fetch(`https://www.limshmi.com/lims-blogs/wp-json/wp/v2/posts/${id}?_embed`)
            .then(res => res.json())
            .then(data => setBlog(data))
            .catch(err => console.error(err));
    }, [id]);

    if (!blog) {
        return <p>Loading...</p>;
    }

    return (
        <>
        <div className="blogs-outer">
                <div className="blogs-inner">
                    <h2 className="header-text">Blogs</h2>
                    <p className='letter-text'>
                        Welcome to our blog section! Here, we share insights, updates, and stories related to our community and activities.
                    </p>
                </div>
            </div>
            <div className="one-blog-outer container">
                <div className="one-blog-inner">
                    <div className="blog-featured-image">
                        <img
                            src={blog._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/default.jpg'}
                            alt={blog.title.rendered}
                            loading="lazy"
                        />
                    </div>
                    <h1 className="blog-title secondary-header">{blog.title.rendered}</h1>
                    <p className="blog-author cta-text">Author: {blog._embedded?.author?.[0]?.name || 'Unknown'}</p>
                    <p className="blog-date letter-text">Published on: {new Date(blog.date).toLocaleDateString()}</p>
                    <div
                        className="blog-content paragraph-text"
                        dangerouslySetInnerHTML={{ __html: blog.content.rendered }}
                    />
                </div>
            </div>
        </>
    );
}

export default OneBlog;
